/** Инвайт-ссылка: t.me/+hash или t.me/joinchat/hash (протокол/www опциональны). */
const INVITE_RE =
  /^(?:https?:\/\/)?(?:www\.)?t\.me\/(?:\+|joinchat\/)[A-Za-z0-9_-]+$/
/** Юзернейм Telegram: 4–32 символа [A-Za-z0-9_]. */
const USERNAME_RE = /^[A-Za-z0-9_]{4,32}$/
/** t.me-ссылка на юзернейм (протокол/www опциональны). */
const TME_USERNAME_RE =
  /^(?:https?:\/\/)?(?:www\.)?t\.me\/([A-Za-z0-9_]{4,32})$/

/**
 * Нормализация одной строки:
 * - `username` / `@username` / `t.me/username` (с протоколом или без) → `username`;
 * - инвайт-ссылка (`t.me/+hash`, `t.me/joinchat/hash`) → как есть;
 * - пустое/невалидное → null.
 */
export function normalizeTelegramLink(raw: string): string | null {
  const s = raw.trim()
  if (!s) return null
  if (INVITE_RE.test(s)) return s
  const tme = s.match(TME_USERNAME_RE)
  if (tme) return tme[1]
  const uname = s.startsWith("@") ? s.slice(1) : s
  if (USERNAME_RE.test(uname)) return uname
  return null
}

export interface ParsedLinks {
  links: string[]
  discardedCount: number
}

/**
 * Разбор textarea: по строке на ссылку → нормализация → дедупликация
 * с сохранением порядка. Пустые строки, дубликаты и невалидные строки
 * отбрасываются и считаются в discardedCount.
 */
export function parseTelegramLinks(text: string): ParsedLinks {
  if (!text.trim()) return { links: [], discardedCount: 0 }
  const seen = new Set<string>()
  const links: string[] = []
  let discardedCount = 0
  for (const line of text.split("\n")) {
    const n = normalizeTelegramLink(line)
    if (n === null || seen.has(n)) {
      discardedCount++
      continue
    }
    seen.add(n)
    links.push(n)
  }
  return { links, discardedCount }
}
